export interface ProjectStateI {
  token: string;
}

export const state: ProjectStateI = {
  token: '',
};
